import React, { useMemo } from 'react';
import { useParams, generatePath } from 'react-router-dom';

import ROUTES_PATH from '@/router/routesPathConfig';

import BackToArrowBase from '@/components/mui/Layouts/components/BackToArrowBase';

import { flowStates } from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/Workspace/components/PaymentFlowStates';

const BackToArrow = () => {
  const { companyId } = useParams();

  const path = useMemo(() => {
    const query = new URLSearchParams({
      flowState: flowStates.paymentPreparation,
    }).toString();
    const str = generatePath(ROUTES_PATH.PAY_COMPANY.absolute, { companyId });
    return `${str}?${query}`;
  }, [companyId]);

  return <BackToArrowBase path={path} />;
};

export default BackToArrow;
